"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDomainDifferent = void 0;
/**
 *
 * @param a TDomainAdapter
 * @param b TDomainAdapter
 * @returns True if a and b are both defined and have different id´s
 */
const isDomainDifferent = (a, b) => a?.id && b?.id && a.id !== b.id;
exports.isDomainDifferent = isDomainDifferent;
